import { VendorProductCode } from '../../@types/InventoryDS'
import { getAPIURL } from '../../GlobalComponents/URLs'
import { TechPartnerDashboardInput } from '../../TechPartner/TechPartnerDashboard/TechPartnerDashboard'
import { InventoryFulfillmentTypes } from '../../TechPartner/Components/SectionData/FulfillmentProcessData'
import { SortDescriptor } from '@progress/kendo-data-query'
export interface GetTechPartnerSalesAndPlanParams {
    VendorIDProductCodes: Array<VendorProductCode>
    SalespersonCodes: Array<string>
}

export interface YTDData {
    YTD: number
    PYTD: number
}

export const fetchTechPartnerBookings = async (
    params: TechPartnerDashboardInput
): Promise<YTDData> => {
    let url = `${getAPIURL()}sales/techpartner/bookings`

    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
    })
    let json: YTDData = await req.json()
    return json
}
export interface MonthlySalesData {
    MonthAge: number
    Sales: number
}

export interface TechPartnerSalesResults {
    ReportPeriodSalesYTD: number
    ReportPeriodSalesPYTD: number
    CalendarYearSalesYTD: number
    CalendarYearSalesPYTD: number
    CalendarYearCOGSYTD: number
    CalendarYearCOGSPYTD: number
}

export const fetchTechPartnerPlan = async (
    params: TechPartnerDashboardInput
): Promise<Array<MonthlySalesData>> => {
    let url = `${getAPIURL()}sales/techpartner/plan`

    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
    })
    let json: Array<MonthlySalesData> = await req.json()
    return json
}

export const fetchTechPartnerSales = async (
    params: TechPartnerDashboardInput
): Promise<TechPartnerSalesResults> => {
    let url = `${getAPIURL()}sales/techpartner/sales`

    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
    })
    let json: TechPartnerSalesResults = await req.json()
    return json
}
export interface YearlySalesQuotaData {
    VendorID: string
    Year: number
    QuotaBy: number
    QuotaAssignedTo: string
    Quota: number
}

export const fetchTechPartnerSalesQuota = async (
    params: TechPartnerDashboardInput
): Promise<Array<YearlySalesQuotaData>> => {
    let url = `${getAPIURL()}sales/techpartner/salesquota`

    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
    })
    let json: Array<YearlySalesQuotaData> = await req.json()
    return json
}
export interface CAGRData {
    P5YSales: number
    P4YSales: number
    P3YSales: number
    P2YSales: number
    PYSales: number
    CYSales: number
    CYRunRate: number
    YTDGoal: number
    P3YSalesGrowthRate: number
    P2YSalesGrowthRate: number
    PYSalesGrowthRate: number
    CYRunRateGrowthRate: number
    P3YearCAGR: number
    P5YearCAGR: number
    POSReportPresent: boolean | null
}

export const fetchTechPartnerCAGR = async (
    params: TechPartnerDashboardInput
): Promise<CAGRData> => {
    let url = `${getAPIURL()}sales/techpartner/cagr`

    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
    })
    let json: CAGRData = await req.json()
    return json
}

export const fetchTechPartnerBacklog = async (
    params: TechPartnerDashboardInput
): Promise<number> => {
    let url = `${getAPIURL()}sales/techpartner/backlog`

    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
    })
    let json: number = await req.json()
    return json
}
export interface CostData {
    MonthAge: number
    Cost: number
}

export const fetchTechPartnerCOGS = async (
    params: TechPartnerDashboardInput
): Promise<Array<CostData>> => {
    let url = `${getAPIURL()}sales/techpartner/cogs`

    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
    })
    let json: Array<CostData> = await req.json()
    return json
}

export interface IndustryClassSalesData {
    IndustryClassification: string
    Sales: number
}

export const fetchTechPartnerSalesByIndustryClass = async (
    params: TechPartnerDashboardInput & { Period: string }
): Promise<Array<IndustryClassSalesData>> => {
    let url = `${getAPIURL()}sales/techpartner/industryclass`

    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
    })
    let json: Array<IndustryClassSalesData> = await req.json()
    return json
}

export interface CustomerTypeSalesData {
    CustomerType: string
    Sales: number
}

export const fetchTechPartnerSalesByCustomerType = async (
    params: TechPartnerDashboardInput & { Period: string }
): Promise<Array<CustomerTypeSalesData>> => {
    let url = `${getAPIURL()}sales/techpartner/customertype`

    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
    })
    let json: Array<CustomerTypeSalesData> = await req.json()
    return json
}

export interface SalesOpportunityData {
    Stage: string
    Weight: number
    SortOrder: number
    YTD: number
    PYTD: number
    Delta: number
    DeltaPercent: number
    PercentOfStages: number
}

export const fetchSalesOpportunity = async (
    params: TechPartnerDashboardInput
): Promise<Array<SalesOpportunityData>> => {
    let url = `${getAPIURL()}sales/techpartner/salesopportunity`

    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
    })
    let json: Array<SalesOpportunityData> = await req.json()
    return json
}

export interface SalesProcessSalesLabelData {
    Label: string
    SecondaryLabel: string
    SortOrder: number
}

export interface SalesProcessSalesData {
    Label: string
    SecondaryLabel: string
    SortOrder: number
    YTD: number | null
    PYTD?: number
    Delta?: number
    DeltaPercent?: number
    Plan?: number
    QuotaYoY?: number
    Gap?: number
    GapPercent?: number
}

// export const fetchSalesProcessSales = async (
//     params: TechPartnerDashboardInput
// ): Promise<Array<SalesProcessSalesData>> => {
//     let url = `${getAPIURL()}sales/techpartner/salesprocesssales`

//     let req = await fetch(url, {
//         credentials: 'include',
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(params),
//     })
//     let json: Array<SalesProcessSalesData> = await req.json()
//     return json
// }

export interface FulfillmentPurchaseData {
    MonthlyData: Array<FulfillmentMonthlyPurchaseData>
    PastDuePOs: number
}
export interface FulfillmentMonthlyPurchaseData {
    MonthAge: number
    Cost: number
}
export interface FulfillmentInventoryData {
    // MonthlyData: Array<FulfillmentMonthlyInventoryData>
    SummaryData: Array<FulfillmentInventorySummaryData>
    Turns: number
}
export interface FulfillmentInventorySummaryData {
    TitlePrimary: string
    TitleSecondary: string
    AvailableCost: number
    TotalCost: number
    DeadCost: number
    Aged012Cost: number
    Aged1324Cost: number
    Aged2536Cost: number
    AgedOver36Cost: number
}
export interface FulfillmentMonthlyInventoryData {
    MonthAge: number
    ValueReceived: number
    ValueShipped: number
}

export const fetchTechPartnerFulfillmentProcessPurchaseData = async (params: {
    Inputs: TechPartnerDashboardInput
    InventoryFulfillmentType: InventoryFulfillmentTypes
}): Promise<FulfillmentPurchaseData> => {
    let url = `${getAPIURL()}purchasing/techpartner/fulfillment`

    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
    })
    let json: FulfillmentPurchaseData = await req.json()
    return json
}

export const fetchTechPartnerFulfillmentProcessInventoryData = async (params: {
    Inputs: TechPartnerDashboardInput
    InventoryFulfillmentType: InventoryFulfillmentTypes
}): Promise<FulfillmentInventoryData> => {
    let url = `${getAPIURL()}inventory/techpartner/fulfillment`

    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
    })
    let json: FulfillmentInventoryData = await req.json()
    return json
}

export interface CustomersSalesData {
    [index: string]: string | number
    CustomerName: string
    YTDSales: number
    PYTDSales: number
    P2YTDSales: number
    P3YTDSales: number
    P4YTDSales: number
    P5YTDSales: number
    P5YearCAGR: number
    CustomerType: string
    IndustryClassification: string
    CustomersOffset: string
}

export interface CustomersFilterInputData {
    OrderBy: SortDescriptor[]
    CustomerName: string
    CustomerType: string[]
    IndustryClassification: string[]
    CustomersOffset: string
    Totals: boolean
}

export const fetchCustomers = async (
    params: TechPartnerDashboardInput & { CustomerFilters: CustomersFilterInputData },
    controller: AbortController
): Promise<CustomersSalesData[]> => {
    let url = `${getAPIURL()}sales/techpartner/customers`

    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
        signal: controller.signal,
    })
        .then((resp) => {
            if (resp.ok) {
                return resp.json()
            } else throw new Error(`bad request ${resp.statusText}`)
        })
        .catch((err) => {
            console.error('Error fetching')
        })
    let json: CustomersSalesData[] = await req
    return json
}

export const fetchNewCustomerCount = async (
    params: TechPartnerDashboardInput,
    controller: AbortController
): Promise<number> => {
    let url = `${getAPIURL()}sales/techpartner/newcustomers`

    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
        signal: controller.signal,
    })
        .then((resp) => {
            if (resp.ok) {
                return resp.json()
            } else throw new Error(`bad request ${resp.statusText}`)
        })
        .catch((err) => {
            console.error('Error fetching')
        })
    let json: number = await req
    return json
}

export interface TeamResourcesSalesData {
    EmployeeNo: string
    Name: string
    Department: string
    Position: string
    YTDPlan: number
    YTDSales: number
    PercentOfTotal: number
    NumberOfCustomers: number
    NumberOfTargetAccounts: number
    TechnicalKnowledge: number | null
    SalesKnowledge: number | null
}

export const fetchTeamResources = async (
    params: TechPartnerDashboardInput,
    controller: AbortController
): Promise<TeamResourcesSalesData[]> => {
    let url = `${getAPIURL()}sales/techpartner/teamresources`

    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
        signal: controller.signal,
    })
        .then((resp) => {
            if (resp.ok) {
                return resp.json()
            } else throw new Error(`bad request ${resp.statusText}`)
        })
        .catch((err) => {
            console.error('Error fetching')
        })
    let json: TeamResourcesSalesData[] = await req
    return json
}

enum TechPartQuotaBy {
    Company,
    Division,
    SalespersonCode,
}

export interface TechPartnerQuotaImportData {
    Row: number
    VendorID: string
    FiscalYearStartMonth: number
    Year: number
    Category: string
    CategoryRollupDivision: string
    Quota: number
    QuotaBy: TechPartQuotaBy
    QuotaAssignedTo: string
}

export const fetchCheckForTechPartnerQuotaDuplicates = async (
    params: TechPartnerQuotaImportData[]
): Promise<TechPartnerQuotaImportData[]> => {
    let url = `${getAPIURL()}sales/techpartner/checkforquotaduplicates`

    let req: any = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
    })
        .then((resp) => {
            if (!resp.ok)
                return resp.text().then((errorText) => {
                    throw new Error(errorText)
                })
            else return resp.json()
        })
        .catch((err) => {
            throw new Error(err)
        })

    let returnValue: TechPartnerQuotaImportData[] = await req
    return returnValue
}

export const fetchTechPartnerQuotaImport = async (params: TechPartnerQuotaImportData[]) => {
    let url = `${getAPIURL()}sales/techpartner/importquota`

    await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
    })
        .then((resp) => {
            if (!resp.ok)
                return resp.text().then((errorText) => {
                    throw new Error(errorText)
                })
        })
        .catch((err) => {
            throw new Error(err)
        })
}
